/**
 * Generic count formatting — no domain knowledge.
 *
 * Kept next to the percentage maths because "3 consignments" and "50%" are the
 * same kind of thing: a number a person reads off a dashboard, formatted once,
 * the same way everywhere.
 */

/**
 * `"1 pallet"` / `"13 pallets"` — count with a plural-aware unit.
 *
 * English `-s` plural by default; pass `plural` for anything irregular
 * (`pluraliseCount(2, 'lorry', 'lorries')`). The count is locale-formatted so
 * large numbers get their separators (`"1,204 pallets"`).
 */
export function pluraliseCount(count: number, singular: string, plural?: string): string {
  const unit = count === 1 ? singular : (plural ?? `${singular}s`);
  return `${count.toLocaleString()} ${unit}`;
}

/**
 * A count that may not be a whole number (e.g. summed lift figures that carry a
 * fractional pallet). Whole numbers print clean; fractions keep one decimal.
 */
export function formatCount(value: number): string {
  return Number.isInteger(value)
    ? value.toLocaleString()
    : value.toLocaleString(undefined, { maximumFractionDigits: 1 });
}
